module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kf-Lc.833e885f.png";